import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private isSplashScreenActive = new BehaviorSubject<boolean>(true);
  private spinnerCount = 0;
  private isSpinnerVisible = false;

  constructor(private spinner: NgxSpinnerService) { }

  show() {
    if (!this.isSplashScreenActive.value) {
      this.spinnerCount++;
      if (this.spinnerCount === 1 && !this.isSpinnerVisible) {
        this.spinner.show();
        this.isSpinnerVisible = true;
      }
    }
  }

  hide() {
    if (!this.isSplashScreenActive.value) {
      this.spinnerCount = Math.max(0, this.spinnerCount - 1);
      if (this.spinnerCount === 0 && this.isSpinnerVisible) {
        this.spinner.hide();
        this.isSpinnerVisible = false;
      }
    }
  }

  setSplashScreenActive(isActive: boolean) {
    this.isSplashScreenActive.next(isActive);
    if (isActive) {
      this.spinner.hide();
      this.isSpinnerVisible = false;
      this.spinnerCount = 0;
    }
  }

  // Force hide spinner regardless of splash screen state
  forceHide() {
    this.spinner.hide();
    this.isSpinnerVisible = false;
    this.spinnerCount = 0;
  }
}
